<!-- TEMPLATE -->
<template>
  <div class="content-container">
    <div class="row">
      <zoom-y-transition>
        <router-view :key="$route.fullPath"
                     class="small-12 medium-12 large-12 hd-12 columns partners-content"></router-view>
      </zoom-y-transition>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  // VUE
  import Vue from 'vue';
  import { Component, Provide, Watch } from 'vue-property-decorator';
  import { ZoomYTransition } from 'vue2-transitions';

  import {
    // COMPONENTS
    deanSectionTitle,
    deanSectionTitleItem,
    deanSidemenu,
    invoicesIcon,
    commissionIcon,
  } from '@deanone/dean-components';

  @Component({
    components: {
      deanSectionTitle,
      deanSectionTitleItem,
      deanSidemenu,
      invoicesIcon,
      commissionIcon,
      ZoomYTransition,
    },
  })

  export default class BasicNoSideMenu extends Vue {

  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>
  @import "~@deanone/dean-components/src/scss/vars";
</style>
